<template>
    <div>

        <team-modal v-if="isAddEditModalActive" :table-id="tableId" :selected-url="selectedUrl"
            :accreditation-id="accreditationId" :evaluation-id="evaluationId" :file-url="fileUrl"
            :file-url-path="fileUrlPath" @close-modal="closeAddEditModal" />
    
        <app-table :id="tableId" :options="options" @action="getListAction" />

    </div>
</template>

<script>
    import CoreLibrary from "@/core/helpers/CoreLibrary.js";
    import * as actions from "../../../../apiUrl";
    import {
        TabAceptEvaluationTeamHelpers
    } from "../helpers/TabAceptEvaluationTeamHelpers";

    export default {
        extends: CoreLibrary,
        name: "TabAcceptRejectTeam",
        mixins: [TabAceptEvaluationTeamHelpers],
        data() {
            return {
                deleteLoader: false,
                isAddEditModalActive: false,
                deleteConfirmationModalActive: false,
                selectedUrl: "",
                tableId: "accept-rejected-team-list",
                rowData: {},
                options: {
                    url: `${actions.ACCREDITATION_PROCESS}/evaluationTeamInfo/303`,
                    name: this.$t("demo_crud"),
                    showHeader: true,
                    columns: [],
                    actions: [{
                        title: this.$t("Revisar solicitud"),
                        icon: "eye",
                        type: "none",
                        component: "team-modal",
                        modalId: "team-id-modal",
                    }, ],
                    showFilter: false,
                    showSearch: false,
                    paginationType: "pagination",
                    responsive: true,
                    rowLimit: 10,
                    showAction: true,
                    orderBy: "desc",
                    actionType: "default",
                },
            };
        },
        created() {
            this.$hub.$on("reload-table", () => {
                this.$hub.$emit("reload-" + this.tableId);
            });
            this.options.columns = [...this.tableColumns, this.actionObj];
        },
        methods: {
            openAddEditModal() {
                this.isAddEditModalActive = true;
            },
            closeAddEditModal() {
                $("#team-id-modal").modal("hide");
                this.isAddEditModalActive = false;
                this.reSetData();
            },
            getListAction(rowData, actionObj, active) {
                this.rowData = rowData;
                this.accreditationId = rowData.accreditation_id;
                this.evaluationId = rowData.id;
                const accType = this.rowData.accreditation_applications.accreditation_type.name;
                if (this.rowData.file_evaluation) {
                    if (this.rowData.file_evaluation.type === "evaluation_team_file") {
                        this.fileUrl = rowData.file_evaluation.full_url;
                        this.fileUrlPath = rowData.file_evaluation.path;
                        var key = accType ;
                        if(accType == 'Acreditación Inicial' ){
                            this.$store.dispatch("postEmailAccess",this.evaluationId);
                            this.openAddEditModal();
                        }
                        if(key.match(/Ampliación*/)  || key.match(/Vigilancia*/) || key.match(/Renovación*/) ){
                         /* this.selectedUrl = `${actions.ACCREDITATION_PROCESS}/evaluationTeamDetails/${this.evaluationId}`;
                         window.location = this.selectedUrl; */
                         this.$store.dispatch("postEmailAccess",this.evaluationId);
                         this.openAddEditModal();
                        }
                    } else {
                        this.$toastr.e(`La Evaluación ${this.rowData.code} no tiene archivos adjuntos.`);
                    }
                } else {
                    this.$toastr.e(`La Evaluación ${this.rowData.code} no tiene archivos adjuntos.`);
                }
            },
            openDeleteModal() {
                this.deleteConfirmationModalActive = true;
            },
            confirmed() {
                let url = `${actions.ACCREDITATION_PROCESS}/${this.rowData.id}`;
                this.deleteLoader = true;
                this.axiosDelete(url)
                    .then((response) => {
                        this.deleteLoader = false;
                        $("#pending-delete").modal("hide");
                        this.cancelled();
                        this.$toastr.s(response.data.message);
                    })
                    .catch(({
                        error
                    }) => {
                        //trigger after error
                    })
                    .finally(() => {
                        this.$hub.$emit("reload-" + this.tableId);
                    });
            },
            cancelled() {
                this.deleteConfirmationModalActive = false;
                this.reSetData();
            },
            reSetData() {
                this.rowData = {};
                this.selectedUrl = "";
            }
        },
    };
</script>